module.exports = __webpack_public_path__ + "media/images/mobile/abouts/3-ab6164171b35bb17b7084f22e445765f.jpg";